import { render, staticRenderFns } from "./itemsList.vue?vue&type=template&id=19f8e676&scoped=true&"
import script from "./itemsList.vue?vue&type=script&lang=js&"
export * from "./itemsList.vue?vue&type=script&lang=js&"
import style0 from "./itemsList.vue?vue&type=style&index=0&id=19f8e676&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f8e676",
  null
  
)

export default component.exports